import { render, staticRenderFns } from "./EditVehicleInspection.vue?vue&type=template&id=776add58"
import script from "./EditVehicleInspection.vue?vue&type=script&lang=js"
export * from "./EditVehicleInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditVehicleInspection.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776add58')) {
      api.createRecord('776add58', component.options)
    } else {
      api.reload('776add58', component.options)
    }
    module.hot.accept("./EditVehicleInspection.vue?vue&type=template&id=776add58", function () {
      api.rerender('776add58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/views/EditVehicleInspection.vue"
export default component.exports